import { toast } from "react-toastify";

class NotificationService {
  constructor() {
    this.audioRef = null;
    this.soundEnabled = this.getSoundPreference();
    this.initializeAudio();
  }

  // ✅ تهيئة الصوت
  initializeAudio() {
    if (typeof window !== 'undefined') {
      this.audioRef = new Audio("/notification.mp3");
      this.audioRef.volume = 0.7;

      // ✅ تفعيل الصوت عند أول تفاعل
      const enableAudio = () => {
        if (this.audioRef) {
          this.audioRef.play().then(() => {
            this.audioRef.pause();
            this.audioRef.currentTime = 0;
          }).catch(() => {
            // ignore - المستخدم لسه محتاج يتفاعل
          });
        }
        document.removeEventListener('click', enableAudio);
        document.removeEventListener('keydown', enableAudio);
      };

      document.addEventListener('click', enableAudio, { once: true });
      document.addEventListener('keydown', enableAudio, { once: true });
    }
  }

  // ✅ الحصول على تفضيلات الصوت من localStorage
  getSoundPreference() {
    const saved = localStorage.getItem("dailyCardSoundEnabled");
    return saved !== null ? JSON.parse(saved) : true;
  }

  // ✅ حفظ تفضيلات الصوت
  setSoundPreference(enabled) {
    this.soundEnabled = enabled;
    localStorage.setItem("dailyCardSoundEnabled", JSON.stringify(enabled));
  }

  // ✅ تشغيل الصوت
  playSound() {
    if (this.audioRef && this.soundEnabled) {
      this.audioRef.currentTime = 0;
      const playPromise = this.audioRef.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            console.log("✅ Sound played successfully");
          })
          .catch((error) => {
            console.error("❌ Audio play failed:", error);
            toast.warning("🔇 الرجاء الضغط في أي مكان لتفعيل الإشعارات الصوتية", {
              position: "top-center",
              autoClose: 5000,
            });
          });
      }
    }
  }

  // ✅ إظهار Toast
  showToast(message, type = "info") {
    const toastOptions = {
      position: "top-right",
      autoClose: 3000,
      className: "rtl",
    };

    switch (type) {
      case "success":
        toast.success(message, toastOptions);
        break;
      case "error":
        toast.error(message, toastOptions);
        break;
      case "warning":
        toast.warning(message, toastOptions);
        break;
      default:
        toast.info(message, toastOptions);
    }
  }

  // ✅ إشعار كامل (صوت + toast)
  notify(message, playSound = true) {
    if (playSound) {
      this.playSound();
    }
    this.showToast(message, "info");
  }

  // ✅ تفعيل/إيقاف الصوت
  toggleSound() {
    const newState = !this.soundEnabled;
    this.setSoundPreference(newState);

    if (newState) {
      this.showToast("🔔 تم تفعيل الإشعارات الصوتية", "success");
      this.playSound();
    } else {
      this.showToast("🔕 تم إيقاف الإشعارات الصوتية", "info");
    }

    return newState;
  }

  // ✅ تنظيف الموارد
  cleanup() {
    if (this.audioRef) {
      this.audioRef.pause();
      this.audioRef = null;
    }
  }
}

// ✅ إنشاء instance واحد فقط (Singleton)
const notificationService = new NotificationService();

export default notificationService;